import { Component, OnInit } from '@angular/core';
import { ServiceAppService } from '../../../security/service-app.service';

@Component({
  selector: 'app-sobre-lista',
  templateUrl: './sobre-lista.component.html',
  styleUrls: ['./sobre-lista.component.css']
})
export class SobreListaComponent implements OnInit {

  dadosJSON: any[];

  constructor(private service: ServiceAppService) { }

  ngOnInit(): void {
    this.service.getDados('/versao/sobre').subscribe(dados => {
      this.dadosJSON = dados;
    });
  }
}